import React from 'react'
import { Button } from 'pcln-design-system'
import { ArrowUp, ArrowDown, ArrowRight, ArrowLeft } from 'pcln-icons'
import styled from 'styled-components'
import { MarginProps, TextColorProps } from 'styled-system'

const RoundButton = styled(Button)`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  padding: 8px 0;
`

const iconLookup = {
  up: ArrowUp,
  down: ArrowDown,
  left: ArrowLeft,
  right: ArrowRight
} as const

type ArrowButtonProps = {
  direction: keyof typeof iconLookup
  onClick: () => void
  disabled?: boolean
  label: string
} & TextColorProps &
  MarginProps

function ArrowButton({
  direction,
  disabled,
  onClick,
  label,
  ...props
}: ArrowButtonProps) {
  const IconDirection = iconLookup[direction]
  return (
    <RoundButton
      {...props}
      disabled={disabled}
      onClick={onClick}
      data-testid={`arrow${direction}`}
      aria-label={label}
    >
      <IconDirection />
    </RoundButton>
  )
}

export default ArrowButton
